import { initLabelIndex } from '~/labels';

initLabelIndex();
